import { combineReducers } from 'redux';
// Import reducers
import table from './devices_panel_reducer';

export default combineReducers({
	table
});
